<div class="form-group">
  <button type="button" class="btn btn-sm btn-{{ props.btnClass || 'primary' }} }}" (click)="props.clickHandler(field)">
    @if (props.imgSrc) {
      <img [src]="props.imgSrc" alt="" class="pointer" />
    }
    @if (props.icon) {
      <i class="fas fa-{{ props.icon }} {{ props.iconClass }}"></i>
    }
    @if (props.text) {
      {{ props.text }}
    }
    @if (!props.text) {
      <span class="sr-only">{{ key }} </span>
    }
  </button>
</div>
